import _ from 'lodash';

export function setGlossaryList(list) {
  const colors = ['blue', 'yellow', 'orange', 'green', 'purple'];
  const glossary = _.groupBy(list, item => item.letter);
  let index = 0;
  let newList = [];
  _.each(glossary, (value, key) => {
    index = index === 5 ? 0 : index;
    newList.push({
      letter: key,
      items: value,
      color: colors[index]
    });
    index = index + 1;
  });
  return newList;
}

export function findById(list, id) {
  return _.find(list, item => item.id === id);
}

export function objectIsEmpty(o) {
  return Object.keys(o).length === 0;
}

export default {
  setGlossaryList,
  findById,
  objectIsEmpty
};



// WEBPACK FOOTER //
// ./src/pages/identity-glossary/utils.js